import { render, staticRenderFns } from "./TbKeywordsReviewTable.vue?vue&type=template&id=919ffa52&"
import script from "./TbKeywordsReviewTable.vue?vue&type=script&lang=js&"
export * from "./TbKeywordsReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports